export default {
    config: {
        fixedWidth: 80
    },
    default: {
        label: 'Divisiveness'
    },
    unique: [],
    sort: 'rating.divisive',
    lang: {
        name: 'Divisiveness',
        category: 'User',
        description: 'Divisiveness of ratings for the game.',
        views: ['list', 'sheet', 'grid'],
    },
    types: ['group', 'buddies'],
    filters: []
}